var innerRemote;
function attachRemote () {
	innerRemote = __webpack_require__(471);
	var gs = __webpack_require__.g || globalThis
	gs["act-spa-cartera-common"] = innerRemote
	return innerRemote;
};
attachRemote();